/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import dayjs from 'dayjs';
import Types from '../../Types/index'; // tslint:disable-line
import TableDatepicker from '../../../TableDatepicker';
import {
  changeDynamicTableSort,
  IDatepickerSettings,
  setOpenedMenuName,
  setTableDatepickerAtom,
  tablesAtom,
} from '../../../../store/recoil/TableState';
import usePrevious from '../../../../hooks/usePrevious';
import { IDynamicTableState } from '../../../../interfaces/tables';

interface IComponentProps {
  columns: any;
  activeSorting: any;
  activeRows: any;
  label: boolean;
  filterComponent: any;
  reset: any;
  activePaging: any;
  stateValue: any;
  parentState: any;
  cloneProps?: any;
  actionOpen: any;
  setValue: any;
  handleChange?: any;
  actionSave: any;
  intl: any;
  sorting?: any;
  key?: any;
  openedMenuName?: any;
  tableName: string;
  data?: any;
  name?: string;
  id: string;
  save: any;
  countColumns?: number;
  columnsLength?: number;
  modalClassName?: boolean;
}

let setIconSorting = 'asc';

const RIDE_IGNITION_ON = 'ignitionOn';
const RIDE_SPEED = 'speed';
const RIDE_DISTANCE_ADD = 'distanceAdd';
const RIDE_DISTANCE_CUMULATIVE = 'distanceCumulative';

const Item: React.FC<IComponentProps> = ({ ...props }) => {
  const { formatMessage: f } = useIntl();
  const [openMenu, setOpenMenu] = React.useState(false);
  const datepickerSettings = useRecoilValue<IDatepickerSettings | null>(setTableDatepickerAtom);
  const setTables = useSetRecoilState<IDynamicTableState>(tablesAtom);

  const prevTableCalendars: any = usePrevious(
    datepickerSettings ? JSON.stringify(datepickerSettings) : ''
  );
  const prevColumnsName: any = usePrevious(
    props.columns.name ? JSON.stringify(props.columns.name) : ''
  );

  React.useEffect(() => {
    const { columns } = props;
    let prevDateTo = null;
    if (
      datepickerSettings &&
      datepickerSettings[columns.name] &&
      datepickerSettings[columns.name].date.length === 2
    ) {
      const dateFrom = datepickerSettings[columns.name].date[0];
      const dateTo = datepickerSettings[columns.name].date[1];
      if (
        prevTableCalendars &&
        prevColumnsName &&
        prevTableCalendars[prevColumnsName] &&
        prevTableCalendars[prevColumnsName].date
      ) {
        const prevDateFrom = prevTableCalendars[prevColumnsName].date[0];
        if (prevTableCalendars[prevColumnsName].date.length === 2) {
          prevDateTo = prevTableCalendars[prevColumnsName].date[1];
        }
        if (
          JSON.stringify(prevDateFrom) !== JSON.stringify(dateFrom) ||
          dayjs(prevDateTo).format('DD.MM.YYYY HH:mm') !==
            dayjs(dateTo).format('DD.MM.YYYY HH:mm') ||
          (props.filterComponent &&
            props.filterComponent.type &&
            props.filterComponent.active === false)
        ) {
          if (props.filterComponent && props.filterComponent.type) {
            props.actionSave(
              columns.name,
              { min: dateFrom, max: dateTo },
              undefined,
              props.filterComponent.type,
              columns.title
            );
          }
        }
      } else if (props.filterComponent && props.filterComponent.type) {
        props.actionSave(
          columns.name,
          { min: dateFrom, max: dateTo },
          undefined,
          props.filterComponent.type,
          columns.title
        );
      }
    }
  }, [datepickerSettings, prevColumnsName, prevTableCalendars, props]);

  const handlePreventDefault = (e: any) => {
    e.preventDefault();
  };

  const sorting = (e: any) => {
    e.preventDefault();
    const defaultSorting = 'desc';

    const sortingType =
      props.sorting === undefined ? defaultSorting : props.sorting !== 'asc' ? 'asc' : 'desc';

    if (!sortingType) {
      // default
      setTables((oldState) =>
        changeDynamicTableSort(oldState, {
          name: props.tableName,
          sort: defaultSorting,
          columnId: props.columns.name,
        })
      );
    } else {
      setTables((oldState) =>
        changeDynamicTableSort(oldState, {
          name: props.tableName,
          sort: sortingType,
          columnId: props.columns.name,
        })
      );
    }

    if (sortingType === 'desc' && props.sorting !== undefined) {
      setIconSorting = 'asc';
    } else if (sortingType === 'asc' && props.sorting !== undefined) {
      setIconSorting = 'desc';
    } else if (sortingType === 'asc' && setIconSorting) {
      setIconSorting = 'desc';
    } else if (sortingType === 'desc' && setIconSorting) {
      setIconSorting = 'asc';
    }
  };

  const actionOpen = (e: any) => {
    const { tableName, columns } = props;
    e.preventDefault();
    setOpenMenu(true);
    if (
      tableName &&
      e.target.parentElement.className !== 'flatpickr-next-month' &&
      e.target.parentElement.className !== 'flatpickr-prev-month'
    ) {
      setTables((oldState) =>
        setOpenedMenuName(oldState, {
          name: tableName,
          title: columns.name,
          label: false,
          filter: undefined,
        })
      );
    }
  };

  const handleTooltipTitle = (name: string): string => {
    switch (name) {
      case RIDE_IGNITION_ON:
        return f({ id: 'alarms.notificationMessage.templateVariables.ignition' });
      case RIDE_SPEED:
        return f({ id: 'tables.tripsOverview.column.ridePosition.header.speed' });
      case RIDE_DISTANCE_ADD:
        return f({ id: 'tables.tripsOverview.column.ridePosition.header.distanceAdd' });
      case RIDE_DISTANCE_CUMULATIVE:
        return f({ id: 'tables.tripsOverview.column.ridePosition.header.distanceCumulative' });

      default:
        return '';
    }
  };

  const handleClassName = (): string => {
    if (!props.modalClassName) {
      return 'table-dropdown th-sticky';
    }
    if (props.modalClassName) {
      return 'th-sticky-top';
    }
    return '';
  };

  return (
    <th
      key={props.key}
      style={{
        whiteSpace: 'nowrap',
        paddingRight: props.columns.sortable ? '32px' : '7px',
      }}
      className={handleClassName()} // tslint:disable-line
    >
      <div style={{ position: 'relative' }}>
        {props.columns.name === 'locked' ? (
          props.columns.filter ? (
            <span />
          ) : (
            <div style={{ color: '#808080', textAlign: 'center' }}>
              <i className="cmd-icon cmd-icon-lock" />
            </div>
          )
        ) : props.filterComponent && props.filterComponent.type === 'dateRangePicker' ? (
          ''
        ) : props.columns.title ? (
          <span
            id="sibling-hover"
            onClick={actionOpen}
            style={{ cursor: props.columns.filter ? 'pointer' : '' }}
            title={
              props.tableName.includes('ride_positions')
                ? handleTooltipTitle(props.columns.name)
                : ''
            }
          >
            {props.columns.title}
          </span>
        ) : (
          <span>&nbsp;</span>
        )}
        {props.filterComponent !== null && props.filterComponent.type === 'dateRangePicker' && (
          <TableDatepicker
            name={props.columns.name}
            type="head"
            isActive={props.columns.name === 'timestamp' || props.filterComponent.active}
            isLastFilter={props.countColumns === props.columnsLength}
          >
            <span className="datepickerTitle" style={{ cursor: 'pointer' }}>
              {props.columns.title}
              <a
                href=""
                style={{ paddingLeft: '7px', paddingRight: '8px' }}
                onClick={handlePreventDefault}
                data-cy={`filter-button-${props.columns.name}`}
                id={`filter-button-${props.columns.title}`}
                title={f({ id: 'table.filter.button' })}
                className={`cmd-icon cmd-icon-filter fs-3 text-${
                  props.filterComponent == null || !props.filterComponent.active ? 'gray' : 'active'
                } text-decoration-none dropdown-toggle`}
              />
            </span>
          </TableDatepicker>
        )}
        {props.filterComponent !== null &&
          props.filterComponent.type !== 'dateRangePicker' &&
          (props.columns.name === 'locked' ? (
            // <span style={{ color: '#808080', textAlign: 'center', paddingLeft: '20px' }}>
            //   <i className="cmd-icons cmd-icon-lock" />
            // </span>
            <div style={{ textAlign: 'center' }}>
              <a
                href="#"
                style={{ padding: '12px 10px', margin: '12px -10px' }}
                data-cy={`filter-button-${props.columns.name}`}
                onClick={actionOpen}
                title={f({ id: 'table.filter.button' })}
                className={`cmd-icon cmd-icon-lock-table fs-3 text-${
                  props.filterComponent == null || !props.filterComponent.active ? 'gray' : 'active'
                } text-decoration-none dropdown-toggle`}
              />
            </div>
          ) : (
            <a
              href="#"
              style={{ paddingLeft: '7px', paddingRight: '8px' }}
              data-cy={`filter-button-${props.columns.name}`}
              onClick={actionOpen}
              title={f({ id: 'table.filter.button' })}
              className={`sibling-highlight cmd-icon cmd-icon-filter fs-3 text-${
                props.filterComponent == null || !props.filterComponent.active ? 'gray' : 'active'
              } text-decoration-none dropdown-toggle`}
            />
          ))}{' '}
        <div
          style={{
            position: 'absolute',
            top: '-2px',
            // top: props.sorting === 'asc' ? '1px' : '-6px',
            right: '-34px',
            // fontSize: '16px',
          }}
        >
          {props.columns.sortable && (
            <a
              onClick={sorting}
              href="#"
              data-cy={`filter-buttons-sorting-btn-${props.tableName}-${props.columns.name}`}
              title={
                props.sorting !== 'desc'
                  ? f({ id: 'table.filter.desc' })
                  : f({ id: 'table.filter.asc' })
              }
              className={`cmd-icon cmd-icon-sorting-${
                props.sorting === 'asc' ? 'a-z' : 'z-a'
              } text-${
                props.sorting !== undefined ? 'active' : 'gray'
              } text-decoration-none position-relative top-2 ml-xs`}
              style={{ padding: '10px' }}
            />
          )}
        </div>
        {props.filterComponent !== null && openMenu && (
          <div
            style={
              props.countColumns &&
              props.columnsLength &&
              props.columnsLength - props.countColumns < 1 &&
              props.columnsLength > 4
                ? { position: 'absolute', right: '198px', top: '4px' }
                : { position: 'absolute', left: '0', top: '4px' }
            }
          >
            <Types
              activePaging={props.activePaging}
              activeRows={props.activeRows}
              activeSorting={props.activeSorting}
              label={false}
              columns={props.columns}
              name={props.filterComponent.type}
              filterComponent={props.filterComponent}
              stateValue={props.stateValue}
              parentState={props.parentState}
              actionOpen={props.actionOpen}
              setValue={props.setValue}
              actionSave={props.actionSave}
              reset={props.reset}
              openedMenuName={props.openedMenuName}
              tableName={props.tableName}
            />
          </div>
        )}
      </div>
    </th>
  );
};

export default Item;
